import { ITEMS_PER_PAGE } from '@mais-retorno-front/constants/items-per-page';
import { getW3CDatefromDate } from '@mais-retorno-front/helpers/format';
import { getFirstLetterOfString } from '@mais-retorno-front/helpers/util-helpers';
import { ISitemap } from '@mais-retorno-front/models/sitemaps.model';
import { AxiosInstance } from 'axios';

interface IResponse {
  data: {
    glossarios: {
      data: {
        attributes: {
          slug: string;
          path: string;
          updatedAt: string;
        };
      }[];
    };
  };
}

export class GetGlossaryTermsSitemapUseCase {
  constructor(private readonly http: AxiosInstance) {}

  async execute(page: number): Promise<ISitemap[]> {
    const { data } = await this.http.post<IResponse>('', {
      query: `
        query glossaryTerms {
          glossarios(pagination: { page: ${page}, pageSize: ${ITEMS_PER_PAGE.sitemaps} }) {
            data {
              attributes {
                slug
				        path
                updatedAt
              }
            }
          }
        }
      `,
    });

    const terms = data?.data?.glossarios?.data;

    if (!terms || terms.length === 0) {
      return [];
    }

    return terms.map((term) => {
      return {
        url: `${process.env.NEXT_PUBLIC_DOMAIN}${
          term.attributes?.path
        }/${getFirstLetterOfString(term.attributes?.slug)}/${
          term.attributes?.slug
        }`,
        lastMod: `${getW3CDatefromDate(term.attributes?.updatedAt)}`,
      };
    });
  }
}
